export default "__VITE_ASSET__CYB1BQCH__";